import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useUIDSeed } from 'react-uid'
import { i18n as i18next, withTranslation } from 'server/i18n'

import { StaffItem } from 'components/Staff'

import style from './Staff.style'

const StaffStyled = styled.div(props => ({ ...style(props) }))

const Staff = ({ columns, data, i18n }) => {
    const getColumns = () => {
        if (columns === 2 || columns === 4) {
            return columns
        }
        return 4
    }


    const uid = useUIDSeed()

    return data && data.length > 0 ? (
        <StaffStyled columns={getColumns()}>
            <ul className="staffList">
                {data.map(item => (
                    <li key={uid(item)} className="staffList-item">
                        <StaffItem
                            image={item.featuredImage.node.sourceUrl}
                            name={item.title}
                            position={i18n.language === 'en' ? item.acf.position : item.acf.positionDe}
                            speaking={item.acf.languages}
                            description={item.description}
                            columns={getColumns()}
                        />
                    </li>
                ))}
            </ul>
        </StaffStyled>
    ) : null
}

Staff.propTypes = {
    columns: PropTypes.oneOf([2, 4]),
    data: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string,
            name: PropTypes.string,
            position: PropTypes.string,
            speaking: PropTypes.string,
            description: PropTypes.string
        })
    ),
    i18n: PropTypes.oneOfType([() => null, PropTypes.object]).isRequired
}

Staff.defaultProps = {
    columns: 4,
    data: []
}

export default withTranslation()(withTheme(Staff))
